const breakPoint = 1600;
const w = 1172;
const h = w / 1.80;

export const PicWidth = 500;
export const PicDimW = 607.0;
export const PicDimH = 853.0;
export const PicGap = 45;

export const Scrolls = {
  positions: new Map<string, number>(
    [
      ["about", 0],
      ["art", 0],
      ["artist", 0],
      ["home", 0],
      ["galleryAll", 0],
      ["gallerySerie", 0],
      ["painting", 0],
      ["visit", 0]
    ]
  ),
  key: "",
  eventListener: () => {
    if (Scrolls.key === "") return;
    console.log("Set " + Scrolls.key + " to " + window.scrollY);
    Scrolls.positions.set(Scrolls.key, window.scrollY);
  }
}

function myCallback(key: string) {
  Scrolls.key = key;
  console.log("Scroll " + Scrolls.key + " to " + Scrolls.positions.get(Scrolls.key)!);
  window.scrollTo(0, Scrolls.positions.get(Scrolls.key)!);
}

export function ScrollToPosition(key: string) {
  Scrolls.key = "";
  setTimeout(myCallback, 100, key);
}

window.addEventListener('scroll', Scrolls.eventListener);

const LayoutMaxInt = 62;
export const LayoutMaxWidth = LayoutMaxInt + "%";
export const LayoutTextMarginTopHuge = "30px";
export const LayoutTextMarginTopLarge = "20px";
export const LayoutTextMarginTopMedium = "10px";
export const LayoutTextMarginTopSmall = "2px";

export const MediaQueryMobile = "(max-width:660px)";
export const MediaQueryMobileNav = "(max-width:660px), (max-height:660px)";
export const MediaQueryShallow = "(max-height:600px)";
export const MediaQueryScaleMargin = "(max-width:800px)";
export const MediaQueryFixMargin = "(max-width:1150px)";
export const MediaQueryLinebreak = "(max-width:1440px)";
export const MediaQuerySmall1 = "(max-width:" + (breakPoint) + "px)";
export const MediaQuerySmall2 = "(max-width:" + (0.9 * breakPoint) + "px)";
export const MediaQuerySmall3 = "(max-width:" + (0.8 * breakPoint) + "px)";
export const MediaQuerySmall4 = "(max-width:" + (0.7 * breakPoint) + "px)";
export const MediaQuerySmall5 = "(max-width:" + (0.6 * breakPoint) + "px)";

export function initLayoutState1(fixMargin: boolean, scaleMargin: boolean, isMobile: boolean, isSmall1: boolean, isSmall2: boolean, isSmall3: boolean, isSmall4: boolean, isSmall5: boolean) {
  const layoutState = new LayoutState();
  layoutState.init(fixMargin, scaleMargin, isMobile, isSmall1, isSmall2, isSmall3, isSmall4, isSmall5);
  return layoutState;
}

export function initLayoutState2(isMobile: boolean, linebreak: boolean) {
  const layoutState = new LayoutState();
  layoutState.isMobile = isMobile;
  layoutState.linebreak = linebreak;
  return layoutState;
};

export function initLayoutState3(isMobile: boolean) {
  const layoutState = new LayoutState();
  layoutState.isMobile = isMobile;
  return layoutState;
};

export class LayoutState {
  fixMargin: boolean = false;
  scaleMargin: boolean = false;
  isMobile: boolean = false;
  isSmall1: boolean = false;
  isSmall2: boolean = false;
  isSmall3: boolean = false;
  isSmall4: boolean = false;
  isSmall5: boolean = false;
  linebreak: boolean = false;
  isShallow: boolean = false;

  init(fixMargin: boolean, scaleMargin: boolean, isMobile: boolean, isSmall1: boolean, isSmall2: boolean, isSmall3: boolean, isSmall4: boolean, isSmall5: boolean) {
    this.fixMargin = fixMargin;
    this.scaleMargin = scaleMargin;
    this.isMobile = isMobile;
    this.isSmall1 = isSmall1;
    this.isSmall2 = isSmall2;
    this.isSmall3 = isSmall3;
    this.isSmall4 = isSmall4;
    this.isSmall5 = isSmall5;
  };

  paddingTop() {
    if (!this.isShallow) return this.isMobile ? "0" : (this.linebreak ? (252 + 0.0375 * window.visualViewport!.height) + "px" : (224 + 0.0375 * window.visualViewport!.height) + "px");
    return "calc(31.67vH)";
  }

  marginLeft() {
    let marginLeft = "calc(40% - 385px)";
    if (this.fixMargin) marginLeft = "75px";
    if (this.scaleMargin) marginLeft = "calc(35% - 210px)";
    return marginLeft;
  };

  scale() {
    let scale = 1.0;
    if (this.isSmall1) {
      scale = 0.9;
    }
    if (this.isSmall2) {
      scale = 0.8;
    }
    if (this.isSmall3) {
      scale = 0.7;
    }
    if (this.isSmall4) {
      scale = 0.6;
    }
    if (this.isSmall5) {
      scale = 0.5;
    }

    return scale;
  };

  fscale() {
    let scale = 1.0;
    if (this.isSmall1) {
      scale = 0.9;
    }
    if (this.isSmall2) {
      scale = 0.81;
    }
    if (this.isSmall3) {
      scale = 0.72;
    }
    if (this.isSmall4) {
      scale = 0.63;
    }
    if (this.isSmall5) {
      scale = 0.54;
    }

    return scale;
  };
  /*
  if (h > (window.visualViewport!.height - 270)) {
        w = w * (window.visualViewport!.height - 270) / h;
        h = window.visualViewport!.height - 270;
    }*/
  WidthPano() {
    const w1 = w * this.scale();
    const h1 = h * this.scale();
    if (!this.isShallow) {
      if (h1 > (window.visualViewport!.height - 270)) {
        return w1 * (window.visualViewport!.height - 270) / h1;
      }
      else {
        return w1;
      }
    }
    else {
      return "calc(" + w1 + "/" + h1 + "*68.23vH)";
    }
  };

  HeightPano() {
    const h1 = h * this.scale();
    if (!this.isShallow) {
      if (h1 > (window.visualViewport!.height - 270)) {
        return window.visualViewport!.height - 270;
      }
      else {
        return h1;
      }
    }
    else {
      return "calc(68.23vH - 50px)";
    }
  };

  GalleryMaxWidth() {
    return this.isMobile ? "80%" : "800px";
  };

  GalleryWidth() {
    return this.scale() * (3 * (PicWidth * PicDimW / PicDimH + 5) + 2 * PicGap);
  };

  GalleryPaddingTop() {
    if (!this.isShallow) return this.isMobile ? "0px" : (this.linebreak ? "314px" : "286px");
    return "calc(31.67vH)";
  };

  GalleryPaddingLeft() {
    return this.isMobile ? "30px" : "0px";
  }

  GalleryPaddingImageList() {
    return this.isMobile ? "0px 30px" : "5px";
  };

  HomeImageWidth() {
    return this.isMobile ? "90%" : "80%";
  };

  HomeImageHeight() {
    return (this.isShallow) ? ((this.isMobile) ? "calc(100svh - 240px)" : "calc(68.32svh - 30px)") : "calc(100vH - 350px)";
  };

  HomePaddingTop() {
    if (!this.isShallow) return this.isMobile ? "10%" : (this.linebreak ? "320px" : "292px");
    return (this.isMobile) ? "20px" : "calc(31.67vH)";;
  };

  TextBoxMaxWidth() {
    return this.isMobile ? "80%" : "600px";
  };

  TextBoxPaddingTop() {
    return this.isMobile ? "0px" : "25px";
  };

  TextBoxPaddingLeft() {
    return this.isMobile ? "30px" : "0px";
  };

  MainNavPaddingRight() {
    return this.GalleryWidth() - LayoutMaxInt;
  };

  LayoutPanoPaddingTop() {
    if (!this.isShallow) return "250px";
    return this.HomePaddingTop();
  };

  LayoutPaddingBottom() {
    return "60px";
  };

  ArtistWidth() {
    return "calc(100vw - 100px)";
  };

  LogoTop() {
    return this.isShallow ? "calc(6.67vH)" : "40px";
  };

  LogoRight() {
    return this.isShallow ? "calc(6.67vH)" : "40px";
  };

  LogoHeight() {
    return this.isShallow ? "calc(31.67vH)" : "190px";
  };

  LogoHeightImg() {
    return this.isShallow ? "calc(25vH)" : "150px";
  };

  MobileMenuPosition() {
    if (this.isShallow) {
      return "fixed";
    }
    else if (this.isMobile) {
      return "relative";
    }
    else {
      return "fixed";
    };
  }

  MobileMenuTop() {
    if (this.isShallow) {
      return "calc(6.67vH)";
    }
    else if (this.isMobile) {
      return "0px";
    }
    else {
      return "190px";
    }
  };

  MobileMenuLeft() {
    if (this.isShallow) {
      if (this.isMobile) return "20px";
      return this.marginLeft();
    }
    else if (this.isMobile) {
      return "0px";
    }
    else {
      return "30px";
    }
  };

  MobileMenuZIndex() {
    if (this.isShallow) {
      return 10;
    }
    else if (this.isMobile) {
      return 0;
    }
    else {
      return 0;
    }
  };

  MobileMenuPaddingLeft() {
    if (this.isShallow) {
      return "0px";
    }
    else if (this.isMobile) {
      return "30px";
    }
    else {
      return "30px";
    }
  }

}


